import React, { useEffect, useCallback } from "react";
import { toast, ToastBar, Toaster } from "react-hot-toast";
import useDashboardStore from "../../stores/dashboard";
import useUserStore from "../../stores/user";
import CloseIconWhite from "../../assets/svg/icons/common/CloseIconWhite";
import ActiveMerchant from "./components/active-merchant";
import Applications from "./components/applications";
import FilterDrawer from "./components/filter-drawer";
import Header from "./components/header";
import Industries from "./components/industries";
import MonthlyGoals from "./components/monthly-goals";
import PortfolioVolume from "./components/portfolio-volume";
import Stats from "./components/stats";
import Chargebacks from "./components/chargebacks";
import TopResidual from "./components/top-residual";
import MerchantAttrition from "./components/merchant-attrition";
import styles from "./style.module.scss";

import {
  getUserPortfolioSetting,
} from "../../../api";

const DashboardPage = () => {

  const setSettingData = useDashboardStore((state) => state.setSettingData);
  const settingData = useDashboardStore((state) => state.settingData);
  // Same gate as the SideNav Residuals link and the merchant Residuals tab —
  // getTopResidual 403s for these users, so hide the widget rather than render
  // a card that can only fail.
  const canViewResidualData = useUserStore((state) => state.canViewResidualData);

  const fetchPortfolioSetting = useCallback(async () => {
    try {
      const settingResponse = await getUserPortfolioSetting();
      const dbRow = settingResponse?.data;

      if (settingResponse?.success) {
        setSettingData(dbRow)
      }
    } catch (error) {
      console.error("Error portfolio fetching sections:", error);
    } finally {
    }
  }, []);

  useEffect(() => {
    fetchPortfolioSetting();
    return () => {
      useDashboardStore.getState().reset();
    };
  }, []);

const isEnabled = (flag) => {
  // if no data → default to true (show all sections)
  if (!settingData) return true;
  return Boolean(flag);
};

  return (
    <>
      <div className={styles.dashboardPage}>
        <Header />
        {settingData?.number_statistic && <Stats />}

        {(() => {
          const components = [
            isEnabled(settingData?.total_transactions) && (<div className={styles.volumeContainer}><PortfolioVolume key="pv" /></div>),
            isEnabled(settingData?.monthly_goals) && (<div className={styles.goalsContainer}><MonthlyGoals key="mg" /></div>),
            isEnabled(settingData?.industries) && <Industries key="ind" />,
            isEnabled(settingData?.applications) && <Applications key="app" />,
            isEnabled(settingData?.active_merchants) && <ActiveMerchant key="am" />,
            isEnabled(settingData?.chargebacks) && <Chargebacks key="cb" />,
            isEnabled(settingData?.top_residuals) && canViewResidualData && <TopResidual key="tr" />,
            isEnabled(settingData?.merchant_attrition) && <MerchantAttrition key="ma" />,
          ].filter(Boolean); // remove missing components

          // Determine first column size
          const firstColumnSize = isEnabled(settingData?.total_transactions) ? 2 : 3;

          // Slice first column
          const firstColumn = components.slice(0, firstColumnSize);

          // Rest of the components for following columns
          const restComponents = components.slice(firstColumnSize);

          // Split remaining components into chunks of 3
          const chunkSize = 3;
          const otherColumns = [];
          for (let i = 0; i < restComponents.length; i += chunkSize) {
            otherColumns.push(restComponents.slice(i, i + chunkSize));
          }

          return (
            <>            
              {/* First Column */}
              <div className={ isEnabled(settingData?.total_transactions) ? styles.portfolioContainer : `${styles.col3} ${styles.w100}`} key="first-col">
                {firstColumn}
              </div>

              {/* Other Columns */}
              {otherColumns.map((col, idx) => (
                <div className={`${styles.col3} ${styles.w100}`} key={idx}>
                  {col}
                </div>
              ))}
            </>            
          );
        })()}

      </div>

      <FilterDrawer />

      <Toaster
        position="top-right"
        containerStyle={{}}
        toastOptions={{
          style: {
            borderRadius: "8px",
            background: "rgba(40, 39, 45, 0.85)",
            color: "#fff",
            padding: "16px 24px",
          },
          duration: 5000,
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== "loading" && (
                  <button
                    style={{
                      background: "none",
                      padding: "0",
                      margin: "0",
                      border: "none",
                      justifyContent: "center",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={() => toast.dismiss(t.id)}
                  >
                    <CloseIconWhite />
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </>
  );
};

export default DashboardPage;
